import { css } from 'emotion';

import { colors, icons } from '@cobliteam/base-components';

export const checklistReceivedItem = css`
  margin-bottom: 20px;
`;

export const body = css`
  > :not(:first-child) {
    margin-top: 20px;
  }

  > hr:last-child {
    visibility: hidden;
  }

  > div:last-child {
    margin-top: 40px;
  }
`;

export const bodyTip = css`
  display: flex;
`;

export const bodyTipIcon = css`
  color: ${colors.gray.dark};
  margin-right: 10px;
  width: ${icons.size.small};
  height: ${icons.size.small};
`;
